import { render, staticRenderFns } from "./yzzszzj.vue?vue&type=template&id=9c0bd45e&scoped=true&"
import script from "./yzzszzj.vue?vue&type=script&lang=js&"
export * from "./yzzszzj.vue?vue&type=script&lang=js&"
import style0 from "./yzzszzj.vue?vue&type=style&index=0&id=9c0bd45e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0bd45e",
  null
  
)

export default component.exports